import { PayloadAction } from '@reduxjs/toolkit'

import { LoadingStatusEnum } from '../../../../store/types'
import { BrokerIdentifier, BrokerIdentifierList, DeleteBrokerIdentifierRequest } from '../api/types'

import { BrokerIdentifiersState, createDefaultList } from './initialState'

type ThunkMeta<T> = { meta: { arg: T } }

export const GetBrokerIdentifiersReducer = {
  pending: (state: BrokerIdentifiersState) => ({
    ...state,
    loading: LoadingStatusEnum.Pending,
  }),
  fulfilled: (state: BrokerIdentifiersState, action: PayloadAction<BrokerIdentifierList>) => ({
    ...state,
    list: action.payload ?? createDefaultList(),
    loading: LoadingStatusEnum.Succeeded,
  }),
  rejected: (state: BrokerIdentifiersState) => ({
    ...state,
    loading: LoadingStatusEnum.Failed,
  }),
}

export const CreateBrokerIdentifierReducer = {
  pending: (state: BrokerIdentifiersState) => ({
    ...state,
    creating: LoadingStatusEnum.Pending,
  }),
  fulfilled: (state: BrokerIdentifiersState, action: PayloadAction<BrokerIdentifier>) => {
    const identifier = action.payload
    const existingList = state.list[identifier.type] ?? []
    const withoutIdentifier = existingList.filter((item) => item.id !== identifier.id)
    const nextList: BrokerIdentifierList = {
      ...state.list,
      [identifier.type]: [identifier, ...withoutIdentifier],
    }

    return {
      ...state,
      list: nextList,
      creating: LoadingStatusEnum.Succeeded,
    }
  },
  rejected: (state: BrokerIdentifiersState) => ({
    ...state,
    creating: LoadingStatusEnum.Failed,
  }),
}

export const DeleteBrokerIdentifierReducer = {
  pending: (state: BrokerIdentifiersState, action: ThunkMeta<DeleteBrokerIdentifierRequest>) => ({
    ...state,
    deletingId: action.meta.arg.id,
  }),
  fulfilled: (
    state: BrokerIdentifiersState,
    action: ThunkMeta<DeleteBrokerIdentifierRequest> & PayloadAction<void>,
  ) => {
    const id = action.meta.arg.id
    const nextList: BrokerIdentifierList = {
      prop: state.list.prop.filter((identifier) => identifier.id !== id),
      cfd: state.list.cfd.filter((identifier) => identifier.id !== id),
    }

    return {
      ...state,
      list: nextList,
      deletingId: null,
    }
  },
  rejected: (state: BrokerIdentifiersState) => ({
    ...state,
    deletingId: null,
  }),
}
